// Utility — align QBO historical revenues to the wizard's expected ordering.
//
// QBO returns historical revenues as [year_1_gross (most recent), year_2, year_3 (oldest)],
// i.e. newest-first. The Valuation Studio wizard labels its three fields as
// Year 1 (oldest) → Year 3 (most recent), i.e. oldest-first. This util
// performs the index inversion in one place so the [2,1,0] reorder is
// testable rather than scattered inline in the wizard.

/**
 * Convert a QBO newest-first historical revenue array into the wizard's
 * oldest-first ordering. Returns an array of length 3 — entries default to 0
 * when the source array has fewer than 3 entries.
 *
 * @param {number[]|null|undefined} qboHistorical - QBO array, newest-first.
 * @returns {[number, number, number]} [year1 (oldest), year2, year3 (most recent)]
 */
export function alignHistoricalRevenuesToWizardOrder(qboHistorical) {
  const arr = Array.isArray(qboHistorical) ? qboHistorical : [];
  // Newest-first → oldest-first by reading right-to-left in the QBO array.
  const yr3MostRecent = Number(arr[0]) || 0;
  const yr2 = Number(arr[1]) || 0;
  const yr1Oldest = Number(arr[2]) || 0;
  return [yr1Oldest, yr2, yr3MostRecent];
}

/**
 * True when the QBO array has enough data to populate all three wizard
 * year fields. Mirrors the prior `historicalRevenues.length >= 3` guard.
 */
export function hasFullHistoricalRevenues(qboHistorical) {
  return Array.isArray(qboHistorical) && qboHistorical.length >= 3;
}
